<template>
    <div class="row">
        <div class="col-md-12">
            <ParametricSearchComponent :isPublic="true"></ParametricSearchComponent>
        </div>
    </div>
</template>

<script>
    import ParametricSearchComponent from "../../components/parametric-search/ParametricSearch";

    export default {
        name: "parametric-search-page",
        components: {
            ParametricSearchComponent
        }
    };
</script>
